// Submissions.js — CSV backup browser (admin only)
import React, { useState, useEffect } from 'react';
import axios from 'axios';

export function Submissions() {
  const [subs, setSubs] = useState([]);
  const [retention, setRetention] = useState(14);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = () => {
    setLoading(true);
    axios.get('/api/admin/submissions')
      .then(r => { setSubs(r.data.submissions); setRetention(r.data.retention_days); })
      .catch(() => setError('Could not load submissions'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const fmt = (iso) => new Date(iso).toLocaleString();
  const fmtSize = (b) => b < 1024 ? `${b} B` : `${(b / 1024).toFixed(1)} KB`;

  const download = (filename) => {
    // Hit the authenticated endpoint; browser handles the file download.
    window.location.href = `/api/admin/submissions/${encodeURIComponent(filename)}`;
  };

  const remove = (filename) => {
    if (!window.confirm(`Delete ${filename}? This cannot be undone.`)) return;
    axios.delete(`/api/admin/submissions/${encodeURIComponent(filename)}`)
      .then(() => setSubs(s => s.filter(x => x.filename !== filename)))
      .catch(() => setError('Could not delete file'));
  };

  return (
    <div className="admin-card">
      <h2>Submission Backups</h2>
      <p style={{ fontSize: 14, color: 'var(--text-light)', marginBottom: 16 }}>
        Every submission is kept here, so a lost or never-delivered email is never a
        lost application. Each one has a <strong>.json</strong> driver file (the same
        file that is emailed), plus the license photo and signature when the driver
        provided them, and a <strong>.csv</strong> that mirrors the email body for
        quick reading.
      </p>
      <p style={{ fontSize: 14, color: 'var(--text-light)', marginBottom: 16 }}>
        Social Security Numbers are masked to the last four digits everywhere on this
        page. The full number is never written to the server — it exists only in the
        email that was sent to you.
        {retention === 0
          ? ' Files are kept indefinitely; delete them yourself once a driver is processed.'
          : ` Files auto-delete after ${retention} days.`}
      </p>
      {error && <p style={{ color: 'var(--error, #c0392b)', marginBottom: 12 }}>{error}</p>}
      {loading ? <p>Loading...</p> : (
        <div style={{ overflowX: 'auto' }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Submitted</th>
                <th>File</th>
                <th>Size</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {subs.length === 0 ? (
                <tr><td colSpan={4} style={{ color: 'var(--text-light)', textAlign: 'center' }}>No backups on file</td></tr>
              ) : subs.map(s => (
                <tr key={s.filename}>
                  <td style={{ whiteSpace: 'nowrap' }}>{fmt(s.created_at)}</td>
                  <td style={{ wordBreak: 'break-all' }}>{s.filename}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>{fmtSize(s.size_bytes)}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <button className="btn-primary" style={{ marginRight: 8 }}
                      onClick={() => download(s.filename)}>Download</button>
                    <button className="btn-danger"
                      onClick={() => remove(s.filename)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Submissions;
